import {
    Drawer as ChakraDrawer,
    DrawerProps as ChakraDrawerProps,
    DrawerBody,
    DrawerContent,
    DrawerOverlay,
} from '@chakra-ui/react';
import { createContext, useContext, useState } from 'react';
import { useGlobalTrapFocus } from './GlobalTrapFocusContext';

/*
    TODO: Rewrite this with framer, since Chakra doesn't seem to expose 
    the transition animation params at all. Currently way too long & janky,
    and maybe worth dialing in a more polished content fade-in micro-animation.
*/

type DrawerContextType = Pick<ChakraDrawerProps, 'isOpen' | 'onClose'>;

const DrawerContext = createContext<DrawerContextType>({
    isOpen: false,
    onClose: () => false,
});

export const DRAWER_BODY_ID = 'drawer-body';

const Drawer = ({ isOpen, onClose, children, ...props }: ChakraDrawerProps) => {
    const [isFinishedAnimating, setIsFinishedAnimating] = useState(true);
    const { trapFocus } = useGlobalTrapFocus();

    if (!isOpen && isFinishedAnimating) return null;
    if (isFinishedAnimating) setIsFinishedAnimating(false);

    return (
        <DrawerContext.Provider value={{ isOpen, onClose }}>
            <ChakraDrawer
                isOpen={isOpen}
                onClose={onClose}
                trapFocus={trapFocus}
                onCloseComplete={() => setIsFinishedAnimating(true)}
                {...props}
            >
                <DrawerOverlay />
                <DrawerContent p={0} transitionDuration="50ms">
                    <DrawerBody id={DRAWER_BODY_ID} p={0}>
                        {children}
                    </DrawerBody>
                </DrawerContent>
            </ChakraDrawer>
        </DrawerContext.Provider>
    );
};

export default Drawer;

export const useDrawerContext = () => useContext(DrawerContext);
